import dashboardReducer, { dashboardActions } from "./dashboard.slice";

export { dashboardActions };

export default dashboardReducer;
